import { Control, FieldValues } from "react-hook-form";

import { DynamicType } from "models/Types";

export interface ComboBoxStyleProps {
  disabled?: boolean;
  error?: string;
  message?: string;
}

export interface OptionProps {
  label?: string;
  value?: DynamicType;
}

export interface ComboBoxProps extends ComboBoxStyleProps {
  name?: string;
  label?: string;
  onChange?: (item: OptionProps) => void;
  options?: OptionProps[];
  control?: Control<FieldValues>;
  defaultValue?: OptionProps;
  onError?: (clientHeight?: number) => void;
}

export const KEY = {
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  ENTER: "Enter",
};
